import axiosInstance from '@/libs/axios'

const getInitialState = () => ({
  formPolicy: {
    id: null,
    name: '',

    // Escopo N:N. Lista VAZIA significa "todas" — é o que evita um cadastro por par
    // (loja, tabela de preço) numa rede com mais de 80 lojas.
    storeIds: [],
    priceTableIds: [],

    acquirerCostConfigId: null,
    effectiveFrom: null,
    effectiveTo: null,
    priority: 0,

    // Sem valor inicial pré-preenchido: o usuário informa cada limite (Req. 2.15). Sugerir um
    // número faria a loja herdar um limite que ninguém decidiu.
    maxInstallments: null,
    maxInstallmentsWithoutSurcharge: null,
    minInstallmentValue: null,
    minSaleValue: null,

    allowedModes: [],
    defaultMode: null,
    roundInstallment: 'FIRST',
    applySurchargeToCustomer: false,
    // Acrescimo em PERCENTUAL, nao fracao: 6 significa 6%%. Mesma convencao do custo de adquirente,
    // e mesmo cuidado: nao usar o input `text-percetage`, que grava fracao.
    surcharges: [],

    active: true,
  },

  // Valor de referência da tabela de cobertura. Só existe na tela.
  coverageSaleValue: 1000,
  coverageLines: [],

  // Avisos devolvidos pelo backend quando o cadastro é válido mas provavelmente incompleto.
  pendingWarnings: [],
})

export default {
  namespaced: true,
  state: getInitialState(),

  mutations: {
    SET_FORM_POLICY(state, formPolicy) {
      state.formPolicy = formPolicy
    },

    SET_SURCHARGES(state, surcharges) {
      state.formPolicy.surcharges = surcharges
    },

    SET_COVERAGE_SALE_VALUE(state, value) {
      state.coverageSaleValue = value
    },

    SET_COVERAGE_LINES(state, lines) {
      state.coverageLines = lines
    },

    SET_PENDING_WARNINGS(state, warnings) {
      state.pendingWarnings = warnings
    },

    CLEAN_STATE(state) {
      const initial = getInitialState()
      state.formPolicy = initial.formPolicy
      state.coverageSaleValue = initial.coverageSaleValue
      state.coverageLines = initial.coverageLines
      state.pendingWarnings = initial.pendingWarnings
    },
  },

  actions: {
    async fetchById({ commit }, id) {
      const { data } = await axiosInstance.get(
        `/api/settings/financial/installment-policies/${id}`
      )
      commit('SET_FORM_POLICY', {
        ...data,
        acquirerCostConfigId: data.acquirerCostConfigId.toString(),
      })
    },

    /**
     * Salva a política.
     *
     * O backend recusa com 409 quando o cadastro gera avisos ainda não confirmados — por exemplo,
     * faixas de parcelas sem acréscimo cadastrado numa política que repassa. Não é erro de
     * validação: o cadastro é válido, só provavelmente não é o que a pessoa quis. Nesse caso os
     * avisos ficam no estado para a tela perguntar, e o reenvio vai com confirmWarnings.
     */
    async saveForm({ state, commit }, { confirmWarnings = false } = {}) {
      const { id } = state.formPolicy

      try {
        await axiosInstance({
          url: id
            ? `/api/settings/financial/installment-policies/${id}`
            : '/api/settings/financial/installment-policies',
          method: id ? 'PUT' : 'POST',
          data: { ...state.formPolicy, confirmWarnings },
        })

        commit('SET_PENDING_WARNINGS', [])
        return { saved: true, warnings: [] }
      } catch (error) {
        const warnings = error?.response?.status === 409 ? error?.response?.data?.warnings : null

        if (warnings?.length) {
          commit('SET_PENDING_WARNINGS', warnings)
          return { saved: false, warnings }
        }

        throw error
      }
    },

    /**
     * Tabela de cobertura: por quantidade de parcelas, o acréscimo cobrado do cliente, o custo
     * efetivo da adquirente e a margem entre os dois.
     *
     * Vem da API pelo mesmo motivo da simulação de custo: uma única implementação do cálculo.
     */
    async fetchCoverage({ commit, state }) {
      const { id } = state.formPolicy

      if (!id) {
        commit('SET_COVERAGE_LINES', [])
        return
      }

      const { data } = await axiosInstance.get(
        `/api/settings/financial/installment-policies/${id}/coverage`,
        { params: { saleValue: state.coverageSaleValue } }
      )

      commit('SET_COVERAGE_LINES', data?.lines || [])
    },

    setCoverageSaleValue({ commit }, value) {
      commit('SET_COVERAGE_SALE_VALUE', value)
    },

    setSurcharges({ commit }, surcharges) {
      commit('SET_SURCHARGES', surcharges)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
